import { ManagementLoginApprovalMapper } from "@/data/persistences/mappers/ManagementLoginApprovalMapper";
import { LoginApprovalDeleteReviewBody, LoginApprovalDeviceRequest, LoginApprovalDevicesList, LoginApprovalHistoryList, LoginApprovalHistoryRequest, LoginApprovalList, LoginApprovalRequest, LoginReviewBody } from "@/domain/entities/ManagementLoginApproval";
import { ManagementLoginApprovalEndpoint } from "../../endpoints/ManagementLoginApprovalEndpoint";
import ApiService from "../../services/ApiService";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";

export class ManagementLoginApprovalApiRepository {
  private service: ApiService;
  private mapper: ManagementLoginApprovalMapper;
  private endpoints: ManagementLoginApprovalEndpoint;

  constructor(
    service: ApiService,
    mapper: ManagementLoginApprovalMapper,
    endpoints: ManagementLoginApprovalEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getLoginApprovalList(
    params: LoginApprovalRequest
  ): Promise<LoginApprovalList> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getLoginApprovalList(params),
      {}
    );

    return this.mapper.convertLoginApprovalListFromApi(response);
  }

  public async postLoginApprovalReview(
    payload: LoginReviewBody
  ): Promise<ResponsePayloadV2> {
    const response = await this.service.invoke(
      "post",
      this.endpoints.postLoginApprovalReview(),
      undefined,
      payload,
      new Map([["X-Device-ID", payload.deviceIdApproval]])
    );

    return this.mapper.convertFormDataFromApi(response)
  }

  public async getLoginApprovalDevicesList(
    params: LoginApprovalDeviceRequest
  ): Promise<LoginApprovalDevicesList> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getLoginApprovalDevicesList(params),
      {}
    );

    return this.mapper.convertLoginApprovalDevicesListFromApi(response);
  }

  public async postLoginApprovalDeviceDelete(
    payload: LoginApprovalDeleteReviewBody
  ): Promise<boolean> {
    await this.service.invoke(
      "post",
      this.endpoints.postLoginApprovalDeviceDelete(),
      undefined,
      payload
    );

    return true;
  }

  public async getLoginApprovalHistoryList(
    params: LoginApprovalHistoryRequest
  ): Promise<LoginApprovalHistoryList> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getLoginApprovalHistoryList(params),
      {}
    );

    return this.mapper.convertLoginApprovalHistoryListFromApi(response);
  }
}
